//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Component",0,"SelectDisplayableObject",1],[0,"CuttingInterfaceConfigFile",1,1],[0,"CuttingInterfaceOutputFile",1,1],[0,"IncludePlateTemplates",1,0],[0,"InverseBending",1,0],[0,"KnuckledProfile",1,0],[0,"ListFile",1,0],[1,"ManufacturingCollector",0,"Assemblies.SelectComponent",0],[0,"OutputType",1,0],[1,"PartSet",0,"Assemblies.SelectComponentList",0],[0,"VentilationHoles",1,0]],[],[]];
SPLM.Features.ShipDesign.ProfileListBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ProfileListBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ProfileListBuilder.OutputTypes = Object.freeze({
    "ProfileList" : "ProfileList", "XMLOut" : "XMLOut", "All" : "All", "PlateList" : "PlateList"});

export default SPLM;